// NGRX
import { Action } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Update } from '@ngrx/entity';
import { ConfigDebt } from '..';

export enum ConfigDebtActionTypes {
	ConfigDebtOnServerCreated = '[Edit ConfigDebt Component] ConfigDebt On Server Created',
	ConfigDebtCreated = '[Edit ConfigDebt Component] ConfigDebt Created',
	ConfigDebtUpdated = '[Edit ConfigDebt Component] ConfigDebt Updated',
	ConfigDebtsStatusUpdated = '[ConfigDebts List Page] ConfigDebts Status Updated',
	OneConfigDebtDeleted = '[ConfigDebts List Page] One ConfigDebt Deleted',
	ManyConfigDebtsDeleted = '[ConfigDebts List Page] Many Selected ConfigDebts Deleted',
	ConfigDebtsPageRequested = '[ConfigDebts List Page] ConfigDebts Page Requested',
	ConfigDebtsPageLoaded = '[ConfigDebts API] ConfigDebts Page Loaded',
	ConfigDebtsPageCancelled = '[ConfigDebts API] ConfigDebts Page Cancelled',
	ConfigDebtsPageToggleLoading = '[ConfigDebts] ConfigDebts Page Toggle Loading',
	ConfigDebtsActionToggleLoading = '[ConfigDebts] ConfigDebts Action Toggle Loading'
}

export class ConfigDebtOnServerCreated implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtOnServerCreated;

	constructor(public payload: { ConfigDebt: ConfigDebt }) {
	}
}

export class ConfigDebtCreated implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtCreated;

	constructor(public payload: { ConfigDebt: ConfigDebt }) {
	}
}

export class ConfigDebtUpdated implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtUpdated;

	constructor(public payload: {
		partialConfigDebt: Update<ConfigDebt>, // For State update
		ConfigDebt: ConfigDebt // For Server update (through service)
	}) {
	}
}

export class ConfigDebtsStatusUpdated implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtsStatusUpdated;

	constructor(public payload: {
		ConfigDebts: ConfigDebt[],
		status: number
	}) {
	}
}

export class OneConfigDebtDeleted implements Action {
	readonly type = ConfigDebtActionTypes.OneConfigDebtDeleted;

	constructor(public payload: { id: number }) {
	}
}

export class ManyConfigDebtsDeleted implements Action {
	readonly type = ConfigDebtActionTypes.ManyConfigDebtsDeleted;

	constructor(public payload: { ids: number[] }) {
	}
}

export class ConfigDebtsPageRequested implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtsPageRequested;

	constructor(public payload: { page: QueryParamsModel }) {
	}
}

export class ConfigDebtsPageLoaded implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtsPageLoaded;

	constructor(public payload: { ConfigDebts: ConfigDebt[], totalCount: number, page: QueryParamsModel }) {
	}
}

export class ConfigDebtsPageCancelled implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtsPageCancelled;
}

export class ConfigDebtsPageToggleLoading implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtsPageToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export class ConfigDebtsActionToggleLoading implements Action {
	readonly type = ConfigDebtActionTypes.ConfigDebtsActionToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export type ConfigDebtActions = ConfigDebtOnServerCreated
	| ConfigDebtCreated
	| ConfigDebtUpdated
	| ConfigDebtsStatusUpdated
	| OneConfigDebtDeleted
	| ManyConfigDebtsDeleted
	| ConfigDebtsPageRequested
	| ConfigDebtsPageLoaded
	| ConfigDebtsPageCancelled
	| ConfigDebtsPageToggleLoading
	| ConfigDebtsActionToggleLoading;
